<div class="card">
  <div class="card-header">
    <img class="yalo-logo" src="assets/logo/yalocobro-logo.svg" alt="yalo-logo">
    <div class="card-info">
      <ng-content select="[cardInfo]"></ng-content>
    </div>
  </div>

  <div class="card-content" [ngClass]="{'overflow': overflow}">
    <ng-content select="[cardContent]"></ng-content>
  </div>
</div>